import { render, staticRenderFns } from "./LinkQR032.vue?vue&type=template&id=722aebce&scoped=true&"
import script from "./LinkQR032.vue?vue&type=script&lang=js&"
export * from "./LinkQR032.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR032.vue?vue&type=style&index=0&id=722aebce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722aebce",
  null
  
)

export default component.exports